import PropTypes from 'prop-types';
import { memo } from 'react';
import Box from '@mui/material/Box';

function ForbiddenIllustration({ sx, ...other }) {
  return (
    <Box
      component="img"
      src="/assets/illustrations/forbidden_new.png"
      alt="Access Restricted"
      sx={{
        width: '100%',
        maxWidth: 400,
        height: 'auto',
        objectFit: 'contain',
        margin: '0 auto',
        ...sx,
      }}
      {...other}
    />
  );
}

ForbiddenIllustration.propTypes = {
  sx: PropTypes.object,
};

export default memo(ForbiddenIllustration);
